import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { PosthogService } from './posthog.service';

export function providePosthog(key: string | undefined): EnvironmentProviders[] {
  return key
    ? [
      provideAppInitializer(() => inject(PosthogService).initialize(key))
    ]
    : [];
}
